/**
 * 获取用户认证token
 * @returns {string | null} token值或null
 */
export const getToken = (): string | null => {
  return localStorage.getItem('token');
};

/**
 * 设置用户认证token
 * @param {string} token - token值
 */
export const setToken = (token: string): void => {
  localStorage.setItem('token', token);
};

/**
 * 移除用户认证token
 */
export const removeToken = (): void => {
  localStorage.removeItem('token');
};